export const role = {
    'admin': 'Administrator',
    'profileType.trainer': 'Profil trenera',
    'profileType.player': 'Profil użytkownika',
    'profileType.club': 'Profil klubu',
    'developer': 'Developer',
};
